module.exports = __webpack_public_path__ + "static/img/office (10).d1db85f3.jpg";